import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import WelcomeSearch from "@/components/SearchResults/WelcomeSearch.vue";
import EmptyResults from "@/components/SearchResults/EmptyResults.vue";
import ModuleNavigation from "@/components/SearchResults/ModuleNavigation.vue";
import ModuleDataContainer from "@/components/SearchResults/ModuleData/ModuleData.vue";

import { list } from "@/busData";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


function initSearch(list: Record<string, unknown>) {
  if (Object.keys(list).length === 0) {
    return true
  }
  return false
}

function emptyResults(list: Record<string, unknown>) {
  if (Object.values(list).reduce((partialSum: any, a) => partialSum + a, 0) == 0) {
    return true
  }
  return false
}


return (_ctx: any,_cache: any) => {
  return (initSearch(_unref(list)))
    ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
        _createVNode(WelcomeSearch)
      ])
    : (emptyResults(_unref(list)))
      ? _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
          _createVNode(EmptyResults)
        ])
      : _renderSlot(_ctx.$slots, "default", { key: 2 }, () => [
          _createVNode(ModuleNavigation),
          _createVNode(ModuleDataContainer, { list: _unref(list) }, null, 8, ["list"])
        ])
}
}

})